import PAGES from './page';

export default {
  // SIDE_BAR_HIDDEN: 1200, // 默认收起
  SIDE_BAR_HIDDEN: 1440, // 默认收起
  SIDE_BAR_WIDTH: 180, //展开
  MIN_SIDEBAR_WIDTH: 60, //收起
  HEADER_HEIGHT: 48, // header
  /** 不展示左侧栏的页面 */
  HIDE_SIDEBAR_PAGES: [
    PAGES.BOOK_CREATE,
    PAGES.BOOK_CREATE_SUCCESS,
    PAGES.QRCODE_TYPE_SELECT,
    PAGES.QRCODE_MANAGE,
    PAGES.BOOK_UPDATE,
    PAGES.AI_COPYWRITE,
    PAGES.AI_SPEEDREADING,
    PAGES.AI_PAINTING,
    PAGES.AI_TEXT2SPEECH,
    PAGES.BOOK_UPDATE,
    PAGES.DATA_PANEL_BOOK_DETAIL,
    PAGES.BOOK_SELECT,
    PAGES.READER_MESSAGE_ADD,
    PAGES.RESOURCE_SUPER
  ],
  HIDE_HEADER_PAGES: [
    PAGES.QRCODE_MANAGE,
    PAGES.RESOURCE_SUPER
  ]
};
